import React, { useState, useEffect, useCallback, useRef } from "react";
import { INDEX_URL, CUST, icons, FLAVOR } from "../helpers/constants";
import StolenModeMap from "../components/Map/StolenModeMap";

const StolenMode = (props) => {

    return (
		<>
            <StolenModeMap />
		</>
	);
};

export default StolenMode;
